import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer,
} from "recharts";

/**
 * data: [{ axis: string, oms: number }]
 * OMS is 1-9 where lower = more mature. We plot a "maturity" value (10 - oms)
 * so a fuller shape = stronger maturity, which reads intuitively.
 */
export const RadarChartCard = ({ data, height = 360 }) => {
  const chartData = data.map((d) => ({
    axis: d.axis,
    maturity: +(10 - d.oms).toFixed(1),
    oms: d.oms,
  }));

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={chartData} outerRadius="72%">
        <PolarGrid stroke="#E5E7EB" />
        <PolarAngleAxis
          dataKey="axis"
          tick={{ fill: "#1B3A6B", fontSize: 11, fontWeight: 600 }}
        />
        <PolarRadiusAxis domain={[0, 9]} tick={{ fill: "#94A3B8", fontSize: 10 }} angle={90} />
        <Radar
          name="Maturity"
          dataKey="maturity"
          stroke="#1B3A6B"
          strokeWidth={2}
          fill="#1A6B5A"
          fillOpacity={0.2}
          dot={{ r: 3, fill: "#1A6B5A" }}
          isAnimationActive={false}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default RadarChartCard;
